module.exports = __webpack_public_path__ + "static/img/11_4Archive_16e_KaprowCZbooklet_17.6c81fe7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kaprow/archive/11_4Archive_16e_KaprowCZbooklet_17.jpg
// module id = nFKa
// module chunks = 0